module.exports = __webpack_public_path__ + "static/media/c105_cd2.3c74edd9.jpeg";